import React from 'react';
import { Form } from 'antd';
import { isPossiblePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js/mobile';
import { CountryPhoneInput } from '../AntdCountryPhoneInput/phone-input.js';
import { ConfigProvider } from '../AntdCountryPhoneInput/config.js';
import { EN, ZH } from '@yaotai/common-utils';
import en from './countries/en/world.json.js';
import zh from './countries/zh/world.json.js';
import { LabelName } from '../LabelName/index.js';
import { POSSIBLE_COUNTRY_SHORT_LIST } from './helper.js';
import { CountryPhoneContainer, MobileInputStyle } from './styles.js';
import './CountryPhone.js';
import 'antd-mobile';

const COUNTRY_PHONE_LOCAL_CONFIG = {
    [EN]: {
        mobileNumber: 'Mobile Number',
        mobilePlaceholder: 'Phone number',
        errorPhoneText: 'Phone number format error',
    },
    [ZH]: {
        mobileNumber: '手机',
        mobilePlaceholder: '请输入手机号',
        errorPhoneText: '手机格式不正确',
    },
};
const CountryPhoneField = ({ hasLabel = true, required = true, validateTrigger = ['onBlur'], moreValidateRule = [], info, hidden = false, labelStyle, language = ZH, placeholder, isMobile = false, moreInputProps, inputSize = 'large', type = 'center', name = 'phone', label = '手机', validateFirst = true, className, }) => {
    return (React.createElement(CountryPhoneContainer, { isMobile: isMobile },
        isMobile && React.createElement(MobileInputStyle, null),
        React.createElement(ConfigProvider, { locale: language === EN ? en : zh, areaSorter: () => 0, areaMapper: area => {
                return {
                    ...area,
                    emoji: null,
                };
            } },
            React.createElement(Form.Item, { required: required, label: hasLabel ? (type !== 'admin' ? (React.createElement(LabelName, { name: COUNTRY_PHONE_LOCAL_CONFIG[language]['mobileNumber'], info: info, labelStyle: labelStyle })) : (label)) : undefined, className: `international-phone-field ${inputSize}  ${type} ${className}`, name: name, hidden: hidden, validateTrigger: validateTrigger, initialValue: {
                    code: 86,
                    phone: '',
                    short: 'CN',
                }, validateFirst: validateFirst, rules: [
                    {
                        validator: async (_, value) => {
                            if (!value)
                                return Promise.resolve();
                            const { phone, short } = value;
                            if (!phone && !required)
                                return Promise.resolve();
                            else if (!phone)
                                return Promise.reject(COUNTRY_PHONE_LOCAL_CONFIG[language]['mobilePlaceholder']);
                            const _isValidFunc = POSSIBLE_COUNTRY_SHORT_LIST.includes(short)
                                ? isPossiblePhoneNumber
                                : isValidPhoneNumber;
                            return /^[\d]+$/.test(phone) && _isValidFunc(phone, short)
                                ? Promise.resolve()
                                : Promise.reject(COUNTRY_PHONE_LOCAL_CONFIG[language]['errorPhoneText']);
                        },
                    },
                    ...moreValidateRule,
                ] },
                React.createElement(CountryPhoneInput, { selectProps: { showSearch: !isMobile }, placeholder: placeholder, ...moreInputProps, className: 'mobile-input' })))));
};

export { COUNTRY_PHONE_LOCAL_CONFIG, CountryPhoneField };
